/** Stripe-„S" (Markenzeichen, Pfad aus simple-icons, CC0) — nur für den
 *  internen Super-Admin-Knopf „Stripe-Dashboard" auf der Organisationsseite,
 *  damit auf einen Blick klar ist, dass er zu Stripe führt und nicht ins
 *  Kundenportal. Auf das 26er-Raster gesetzt (20px, 3px Rand), Farbe
 *  `currentColor` — die Stripe-Farbe setzt der Knopf. */
export const stripeIcon = `
<svg width="100%" height="100%" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<g transform="translate(3 3) scale(0.833333)">
<path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.594-7.305h.003z" fill="currentColor"/>
</g>
</svg>
`;
